import { HttpService } from '~/helpers';

const endpoint = 'portal/principal';

const PrincipalService = {
  getAll: (cliente, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAll', [cliente], onSuccess, onError);
  },
  getAllFinanceiro: (cliente, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllFinanceiro', [cliente], onSuccess, onError);
  },
  getAllContato: (arquivo, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllContato', [arquivo], onSuccess, onError);
  },
  getAllRecado: (cliente, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllRecado', [cliente], onSuccess, onError);
  },
};

export default PrincipalService;
